import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { Card, CardBody, Table } from 'reactstrap';
import Spinners from '../../components/Common/Spinner';
import { getPurchaseRequisitionAuditReq, getPurchaseRequisitionDetailsReq } from '../../service/purchaseRequisitionService';
import { setBreadcrumbItems } from '../../store/Breadcrumb/actions';
import { formatDate } from '../../utility/formatDate';

const PurchaseRequisitionTrail = (props) => {
  const { id } = useParams();
  const [orderInfo, setOrderInfo] = useState()
  const [auditTrail, setAuditTrail] = useState();
  const [loading, setLoading] = useState(false)

  const getPurchaseRequisitionDetails = async () => {
    const response = await getPurchaseRequisitionDetailsReq(id);
    const rawData = response?.data;
    setOrderInfo(rawData)
  };

  useEffect(() => {
    const fetchAuditData = async () => {
      try {
        setLoading(true)
        const response = await getPurchaseRequisitionAuditReq(id);
        setAuditTrail(response?.data);
        console.log(response)
      } catch (e) {
        console.error('Failed to fetch purchase requisition audit trail', e);
      }
      finally {
        setLoading(false)
      }
    };

    fetchAuditData();
    getPurchaseRequisitionDetails()
  }, [id]);

  useEffect(() => {
    if (orderInfo?.purchaseRequisitionNumber) {
      props.setBreadcrumbItems('Trail', [
        { title: 'Dashboard', link: '/dashboard' },
        { title: 'Purchase Requisitions', link: '/purchase-requisitions' },
        { title: orderInfo?.purchaseRequisitionNumber, link: `/purchase-requisitions/${id}` },
        { title: 'Trail', link: '#' },
      ]);
    }
  }, [orderInfo?.purchaseRequisitionNumber, id]);

  const latestVersion = auditTrail?.length
    ? Math.max(...auditTrail.map((item) => item.version))
    : null;

  return (
    <Card>
      <CardBody>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <Spinners />
          </div>
        ) : (
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th>Version</th>
                <th>Edited By</th>
                <th>Updated At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {auditTrail &&
                auditTrail.map((entry) => {
                  const isLatest = entry.version === latestVersion;

                  return (
                    <tr key={entry._id}>
                      <td>
                        {`${orderInfo?.purchaseRequisitionNumber} ${isLatest ? '(current)' : `(v${entry?.version})`
                          }`}
                      </td>

                      <td>
                        {entry?.changedBy
                          ? `${entry.changedBy.firstName || ''} ${entry.changedBy.lastName || ''}`.trim()
                          : '-'}
                      </td>

                      <td>
                        {entry.updatedAt
                          ? formatDate(new Date(entry.updatedAt))
                          : '-'}
                      </td>

                      <td>
                        <Link
                          to={
                            isLatest
                              ? `/purchase-requisitions/${id}`
                              : `/purchase-requisitions/${id}/v${entry?.version}/${entry?._id}`
                          }
                          className="btn btn-sm btn-primary"
                        >
                          View
                        </Link>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        )}
      </CardBody>
    </Card>
  );
};

export default connect(null, { setBreadcrumbItems })(PurchaseRequisitionTrail);
